import { render } from "./editExtras.vue?vue&type=template&id=06b7d90a&scoped=true"
import script from "./editExtras.vue?vue&type=script&lang=js"
export * from "./editExtras.vue?vue&type=script&lang=js"

import "./editExtras.vue?vue&type=style&index=0&id=06b7d90a&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b7d90a"]])

export default __exports__